export const GET_SELFTEST = 'roasters/GET_SELFTEST';
export const GET_SELFTEST_SUCCESS = 'roasters/GET_SELFTEST_SUCCESS';
export const GET_SELFTEST_FAILED = 'roasters/GET_SELFTEST_FAILED';